import React from 'react'
import './signin.scss'
import SignInForm from '../../components/organisms/signin-form/signin-form'

const SignIn: React.FC = () => {
  return (
    <div className="signin-page">
      <div className="form-container">
        <SignInForm />
      </div>
    </div>
  )
}

export default SignIn
